export const _setIsLogoutTiming = (state, action) => {
  state.isLogoutTiming = action.payload;
};
